export default __webpack_public_path__ + "static/media/img-stack-for-coins.a43c779d.png";